export const DelistedAssets = [
  389993157, // ALGX
  352620637, // ALGX
  553727907, // 11mike10
  553612041, // 11mike10
  433100599, // 11mike10

  57867695, //ALGX Testnet
  52773530, //Mike Testnet
  52773879, //Mike Testnet
  52772474, //Mike Testnet
  52771043, //Mike Testnet
  52769853, //Mike Testnet
  52769581, //Mike Testnet
  52768943, //Mike Testnet
  25340506, //Mike Testnet
  15175087 //Mike Testnet
]
